









































































import { Vue, Prop, Component } from 'vue-property-decorator';
import BillingDetailed from '@/domain/billing/entity/billing-detailed.entity';
import ItemsDetailed from '@/domain/billing/entity/billing-detailed-entitys.ts/items-detailed.entity';
import UserBusinessUnitService from '@/domain/business-unit/service/business-unit.store';
import BillingInfoContentItemsTable from '../billing-info/billing-info-content-items-table.component.vue';
import BillingInfoContentCalculationsTable from '../billing-info/billing-info-content-calculations-table.component.vue';
import BillingInfoModalLog from '../billing-info/billing-info-modal-log.component.vue';
import BillingPaymentLinks from '../billing-info/payment-link/billing-info-content-payment-link.component.vue';

@Component({
  components: {
    BillingInfoContentItemsTable,
    BillingInfoContentCalculationsTable,
    BillingInfoModalLog,
    BillingPaymentLinks,
  },
})
export default class BillingInfoV2Items extends Vue {
  @Prop({
    required: true,
  })
  billing!: BillingDetailed;

  tab: number = 0;

  search: string = '';

  enablePaymentLink: boolean = UserBusinessUnitService
    .selectedBusinessUnit.enablePaymentLinkGeneration;

  showModalLog: boolean = false;

  logMessages: string[] = [];

  logCreatedDate: string = '';

  logModalKey: number = 0;

  get isPaymentLinkTab(): boolean {
    return this.enablePaymentLink && this.tab === 2;
  }

  get filteredItems(): ItemsDetailed[] {
    return this.billing.items.filter((item: ItemsDetailed) => this.matches([
      item.description, item.contractNumber, item.businessUnitName,
      item.resultCenterName, item.installment,
    ]));
  }

  get calculations(): any[] {
    const calculationsArray: any[] = [];
    this.billing.items.forEach((item: ItemsDetailed) => {
      item.calculations.forEach((calculation: any) => {
        calculation.line = item.line;
        calculationsArray.push(calculation);
      });
    });
    return calculationsArray;
  }

  get filteredCalculations(): any[] {
    return this.calculations.filter((calculation: any) => this.matches([
      calculation.ruleName, calculation.line,
    ]));
  }

  private matches(values: any[]): boolean {
    if (!this.search) return true;
    const term = this.search.toLowerCase();
    return values.some((value: any) => `${value || ''}`.toLowerCase().includes(term));
  }

  updateModalLogState(value: boolean): void {
    this.showModalLog = value;
    if (!value) this.logModalKey += 1;
  }

  openSystemLog(logSummary: any): void {
    this.logMessages = logSummary.summary;
    this.logCreatedDate = logSummary.createdDate;
    this.updateModalLogState(true);
  }
}
